import styled from 'styled-components';

export const Container = styled.div`
  padding: 16px;
`;

export const Content = styled.div`
  padding: 16px;
  background: #ffffff;
  border-radius: 4px;
`;
